





































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import pie from "@/components/Charts/pie.vue";
import * as models from "@/api/models";
import * as api from "@/api";
import moment from "moment";
@Component({ components: { pie } })
export default class TypeStatistics extends Vue {
  chartSettings = {
    labelMap: {
      total: "上报舆情",
    },
    legendName: {
      上报舆情: "",
    },
  };
  chartData: any = {
    columns: ["source", "total"],
    rows: [],
  };
  listData: any = [];
  dates: any = [];
  listQuery: any = {
    currentStartDate: "",
    startDate: "",
    endDate: "",
    type: "",
  };
  search() {
    this.fetchData();
  }
  switchWeek(type: string) {
    this.listQuery.type = type;
    this.fetchData();
  }
  mounted() {
    this.fetchData();
  }
  viewDetails(id: string) {}
  async fetchData(page: number = 1) {
    const data: any = await api.Yq.getSourceStatitics_GET({
      st: this.listQuery.st
        ? new Date(new Date(new Date(this.listQuery.st).toLocaleDateString()).getTime())
        : null,
      et: this.listQuery.et
        ? new Date(
            new Date(new Date(this.listQuery.et).toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 -
              1
          )
        : null,
      startDate: this.listQuery.type ? this.listQuery.currentStartDate : null,
      endDate: this.listQuery.endDate,
      type: this.listQuery.type,
      city: "",
      county: "",
    });

    let dataArr = data.data.result;
    //先清空，避免查询影响
    this.listQuery.currentStartDate = "";
    this.listQuery.currentStartDate = data.data.currentStartDate;
    //先清空，避免查询影响
    this.listData = [];
    //组装数据
    for (let i = 1; i < dataArr.length - 1; i++) {
      let item: any = {};
      item.id = dataArr[i][0];
      item.source = dataArr[i][1];
      item.totalNumber = dataArr[i][2];
      let dateArr: any = [];
      for (let j = 0; j < dataArr[0].length - 3; j++) {
        let dateItem: any = {};
        dateItem.date = dataArr[0][j + 3];
        dateItem.number = dataArr[i][j + 3];
        dateArr.push(dateItem);
      }

      item.dateArr = dateArr;
      this.listData.push(item);
    }
    this.dates = this.listData[0].dateArr;
    //先清空拆线图数据，避免查询干扰
    this.chartData.rows = [];
    this.listData.forEach((item: any) => {
      let data = { source: "", total: 0 };
      data.source = item.source;
      data.total = item.totalNumber;
      if (data.total != 0) {
        this.chartData.rows.push(data);
      }
    });
    this.chartSettings.legendName.上报舆情 = "所涉微博、论坛分布 数据";
  }
}
